import { render, staticRenderFns } from "./InvaList.vue?vue&type=template&id=17864d16&scoped=true&"
import script from "./InvaList.vue?vue&type=script&lang=js&"
export * from "./InvaList.vue?vue&type=script&lang=js&"
import style0 from "./InvaList.vue?vue&type=style&index=0&id=17864d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17864d16",
  null
  
)

export default component.exports